module Meevo.Plugins.WaitList {
    "use strict";

    export class MeevoWaitlistEditor implements angular.IDirective {
        restrict = "E";
        
        templateUrl = "app/plugins/waitList/waitListEditorTemplate.html";

        constructor(
            private $filter: angular.IFilterService,
            private $mdSidenav: any,
            private $rootScope: ng.IRootScopeService,
            private editorService: any) {
            }

        link: ng.IDirectiveLinkFn  = (scope: any, element: JQuery, attrs: angular.IAttributes) => {
            
        }

        static factory(): angular.IDirectiveFactory {
            let directive = ($filter, $mdSidenav, $rootScope, editorService) => {
                return new MeevoWaitlistEditor($filter, $mdSidenav, $rootScope, editorService);
            };

            directive.$inject = ["$filter", "$mdSidenav", "$rootScope", "AppointmentEditorService"];

            return directive;
        }
    }

    angular.module("meevo.plugins.waitList")
        .directive("meevoWaitlistEditor", MeevoWaitlistEditor.factory());
}